import React from 'react';

// Components
import { Box, Button } from 'react-bulma-components';

// Styles
import styles from './Notes.module.scss';

const Notes = ({ data=[], onNoteSave }) => {

    const handleAddNote = (e) => {
        e.preventDefault();
        onNoteSave();
    }
    console.log(data);

    return (
        <>
        <Button disabled size="small" className="gradient">
            NEW Note
        </Button>
        <hr />

        { (!data || data.length === 0) && <div>
            <p>No Notes found</p>
        </div> }
        {
            data && data.length > 0 &&
            <div className={ styles.notes }>
                { data.map((note, idx) => {
                    return <Box key={`note-${idx}`} className={ styles.note}>
                        { note }
                    </Box>
                })}
            </div>
        }
        </>
    )
}

export default Notes;
